export default {
  UNAVAILABLEOVERLAP: {
    TITLE: `Conflicts between schedule and availabilities`,
    SUMMARY: ``
  },
  LEAVEOVERLAPPING: {
    TITLE: `Conflicts between schedule and attendance`,
    SUMMARY: ``
  },
  VACATIONOVERLAPPING: {
    TITLE: `Conflicts between schedule and time off`,
    SUMMARY: ``
  }
}
